<div class="absolute inset-0 z-50">
  <div
    class="fixed backdrop-brightness-50 h-full w-full flex place-content-end"
    (click)="closePopup()"
  >
    <div
      [@openCloseBasket]
      class="flex flex-col bg-white gap-2 p-4 w-96 overflow-y-auto"
      (click)="$event.stopPropagation()"
    >
      <div class="flex flex-col gap-2 items-center justify-between h-full">
        <div class="flex flex-col gap-4 w-full">
          <div class="flex flex-col items-end">
            <button
              class="shadow-md p-2 rounded-full w-10 h-10 opacity-60 hover:opacity-100"
              (click)="closePopup()"
            >
              <fa-icon [icon]="iconX" class="text-md"></fa-icon>
            </button>
          </div>
          @for (item of basketItems; track $index) {
            <div class="flex items-center justify-between gap-4">
              <img
                [src]="item.thumbnailUrl"
                class="h-12 w-12 rounded-lg object-cover"
              />
              <div class="flex-1 flex flex-col">
                <div class="font-semibold">{{ productType[item.type] }}</div>
                <div class="text-gray-500 text-sm">{{ item.name }}</div>
              </div>
              <div class="font-medium">{{ item.price | currency }}</div>
              <button
                (click)="removeItem(item)"
                class="p-1 text-gray-500 hover:text-red-500"
              >
                <fa-icon [icon]="iconTrash" class="text-md"></fa-icon>
              </button>
            </div>
          }
        </div>
        <div class="flex flex-col gap-4">
          <div class="flex flex-col items-end">
            <div class="font-bold text-4xl">
              {{ this.basketTotal | currency }}
            </div>
          </div>
          @if (!this.isBasketEmpty()) {
            <div class="flex flex-row gap-2">
              <button routerLink="/basket" class="primary-button py-4">
                {{ "basket.reviewOrder" | translate }}
              </button>
            </div>
          }
          <div class="flex flex-col items-center">
            <ul class="my-4 list-disc pl-6 text-lg font-bold leading-6">
              <li>{{ "basket.benefits.returns" | translate }}</li>
              <li>{{ "basket.benefits.safePayments" | translate }}</li>
              <li>{{ "basket.benefits.parentApproved" | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
